import CoreApi from '../../api/CoreApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';
import type { QueryFunctionContext } from '@tanstack/react-query';

export type Transaction = Awaited<
  ReturnType<typeof CoreApi.meGetGamificationAccountTransactions>
>['transactions'][0];

type Params = {
  transactionId: number;
};

export const meGetGamificationTransaction = createQueryFn(
  QueryNameSpace.meGetGamificationTransaction,
  async ({ queryKey }: QueryFunctionContext<[string] | [string, Params]>) => {
    const [, params] = queryKey;

    const { transactionId } = params;

    const res = await CoreApi.meGetGamificationTransaction(transactionId);

    return res;
  },
);
